import API from '@app/api';
import Errors from '@app/store/action/errors';
import Notification from '@app/store/action/notification';
import Pending from '@app/store/action/pending';

import ActionHelper from '@module/redux-actions';
import { HttpResponseCodes } from '@module/http/axios/response';

export const actions = ActionHelper.types([
  'GET_BILLING_DETAILS',
  'UPDATE_BILLING_DETAILS_SUCCESS',
]);

export default ActionHelper.generate({
  getBillingDetails(subscriptionId = null) {
    const pendingId = 'getBillingDetails';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.BillingDetails.getBillingDetails(null, {
          pathExtValues: {
            subscriptionId,
          },
        });

        dispatch({
          type: actions.GET_BILLING_DETAILS,
          details: response.body,
        });
      } catch (error) {
        dispatch(Notification.setNotification('error', 'something_went_wrong'));
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  updateBillingDetails(subscriptionId = null, params = {}, notify = true) {
    const pendingId = 'updateBillingDetails';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      // We do not want to submit a vat_number which is only a prefix.
      const data = { ...params };

      if (data.vat_number && data.vat_number.length <= 2) {
        data.vat_number = '';
      }

      try {
        const response = await API.BillingDetails.updateBillingDetails(data, {
          pathExtValues: {
            subscriptionId,
          },
        });

        dispatch({
          type: actions.UPDATE_BILLING_DETAILS_SUCCESS,
          details: response.body,
        });

        if (notify) {
          dispatch(
            Notification.setNotification('notification', 'update_account')
          );
        }

        dispatch(Pending.resetPending(pendingId));
        return response;
      } catch (error) {
        if (error.status === HttpResponseCodes.BAD_REQUEST) {
          dispatch(Errors.setError('billingDetails', error.body.fields));
          dispatch(
            Notification.setNotification('error', 'something_went_wrong')
          );
        } else {
          dispatch(
            Notification.setNotification('error', 'update_account_error')
          );
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
